import $ from 'jquery';
import favorites from '../favorites/favorites';

$(document).ready(function(){
    $('body').on('click', '.px-card-product .like', function(){
        var $parent = $(this).parent(), id = $parent.data('id');
            if ($parent.hasClass('is-liked')) {
                favorites.remove(id);
                $parent.removeClass('is-liked');
            } else {
                favorites.add(id);
                $parent.addClass('is-liked');
            }
    })
})